import React from 'react'
import FilterMultiDate from "./FilterMultiDate"
import SelectSearch from "./SelectSearch"
import {Button, Input} from "antd"

const ReportCallDetailSearch = (props) => {
    const {filters, tenants, onChangeFilters, setFilters, fetchListReportCallDetailVoiceMail} = props

    const _handleChangeSelect = (name, value) => {
        onChangeFilters(name, value ? value + '' : '')
    }

    const _handleChangeInput = (e) => {
        const {name, value} = e.target
        setFilters({
            ...filters, [name]: value,
        })
    }

    const _onChangeDate = (name, value) => {
        if (value) {
            onChangeFilters(name, value)
        }
    }

    const _onFilter = () => {
        fetchListReportCallDetailVoiceMail()
    }

    return (<div className="PageFilters CustomFilter2">
            <FilterMultiDate
                receptionDateFrom={filters?.fromDate}
                receptionDateTo={filters?.toDate}
                onChangeFrom={(value) => _onChangeDate('fromDate', value)}
                onChangeTo={(value) => _onChangeDate('toDate', value)}
            />
            <div className="itemFilter">
                <SelectSearch
                    name="tenantId"
                    value={filters.tenantId ? parseInt(filters.tenantId) : null}
                    onChange={_handleChangeSelect}
                    label="Khách hàng:"
                    listSelect={tenants}
                />
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Số ảo</label>
                    <Input
                        name="shortPhone"
                        filters={filters}
                        value={filters.shortPhone || ''}
                        onChange={_handleChangeInput}
                        placeholder='Nhập số ảo để tìm kiếm'
                        style={{width: "100%"}}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <Button
                    className="ButtonExportAntd"
                    onClick={_onFilter}
                >
                    <span className="material-icons">search</span>
                    <span>Search</span>
                </Button>
            </div>
        </div>
    )
}

export default ReportCallDetailSearch
